<template>
  <div>
    <tabs>
      <tab v-for="(tab, index2) in enabledTabs" :key="index2" :title="tab.label">
        <timesheet-fieldset v-for="(field, index) in tab.fields" :key="index" :layout="field" @change="onChange" />
      </tab>
    </tabs>
  </div>
</template>

<script>
  export default {
    components: { 
      TimesheetFieldset: () => import('../TimesheetFieldset.vue')
    },
    name: "timesheet-group-tabs",
    props: {
      layout: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        layoutData: this.layout
      }
    },
    computed: {
      enabledTabs() {
        return this.layoutData.tabs.filter(e => e.enabled !== false); 
      },
    },
    methods: {
      onChange(e,l,v,i) {
        this.recalculateTotalDuration();
        this.$emit("change", e, l, v, i)
      },
      recalculateTotalDuration() {
        let duration = 0;

        for (const tab of this.layoutData.tabs) {
          let durationTab = 0;
          for (const subLayout of tab.fields) {
            durationTab += subLayout.durationValue ?? 0;
            duration += subLayout.durationValue ?? 0;
          }
          this.$set(tab, 'durationValue', durationTab);
        }

        this.$set(this.layoutData, 'durationValue', duration);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>